export default "__VITE_ASSET__xUn2QCnr__"